import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Layout from './layout'
import Forum from './views/forum'
import LearningHubDiscussion from './views/discussion'

const Routes = (
  <Route path="forum" component={Layout}>
    <IndexRoute component={Forum} />
    <Route path="discussions/:postId" component={LearningHubDiscussion} />
  </Route>
)

export default Routes
